import React from 'react';
import { Page } from 'components';
import ReferenceDataDetail from './ReferenceDataDetail';
import ReferenceDataDetailProvider from './ReferenceDataDetailContext';

let Index = () => {
    return (
        <ReferenceDataDetailProvider>
                <ReferenceDataDetail />
        </ReferenceDataDetailProvider>
    );
}

export default Index;